// src/components/HODLink.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';

const HODLink = ({ hod }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/advisors', { state: { hodId: hod.id } });
  };

  return (
    <span
      className='text-base text-body-color dark:text-dark-6 cursor-pointer'
      onClick={handleClick}
    >
      {hod.legal_advisor_count}
    </span>
  );
};

export default HODLink;